import { MapContainer, Marker, Popup, TileLayer } from "react-leaflet";
import L from "leaflet";

const pinIcon = L.divIcon({
    className: "zen-map-pin",
    iconSize: [28, 36],
    iconAnchor: [14, 34],
    popupAnchor: [0, -30],
    html: `<svg viewBox="0 0 28 36" width="28" height="36" xmlns="http://www.w3.org/2000/svg">
    <path d="M14 0C6.27 0 0 6.27 0 14c0 9.5 14 22 14 22s14-12.5 14-22C28 6.27 21.73 0 14 0z" fill="#6B7C4F" stroke="#1F2418" stroke-width="1.2"/>
    <circle cx="14" cy="14" r="5.5" fill="#F2EDE2"/>
  </svg>`,
});

export default function MapWidget({
    locations,
    center,
    zoom = 10,
    height = 480,
}) {
    if (!locations?.length) return null;
    const mapCenter =
        center ||
        (locations.length === 1
            ? [locations[0].lat, locations[0].lng]
            : [
                  locations.reduce((a, l) => a + l.lat, 0) / locations.length,
                  locations.reduce((a, l) => a + l.lng, 0) / locations.length,
              ]);

    return (
        <div
            data-testid="map-widget"
            className="border border-zen-ink/10 overflow-hidden bg-zen-surface"
            style={{ height }}
            aria-label={`Map showing ${locations.length} ZenZest dispensary locations`}
        >
            <MapContainer
                center={mapCenter}
                zoom={zoom}
                style={{ height: "100%", width: "100%" }}
                scrollWheelZoom={false}
            >
                <TileLayer
                    attribution='&copy; <a href="https://www.openstreetmap.org/">OSM</a> · <a href="https://carto.com/">CARTO</a>'
                    url="https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png"
                />
                {locations.map((loc) => (
                    <Marker
                        key={loc.slug}
                        position={[loc.lat, loc.lng]}
                        icon={pinIcon}
                    >
                        <Popup>
                            <div style={{ minWidth: 200 }}>
                                <strong
                                    style={{
                                        fontFamily:
                                            "Playfair Display, serif",
                                        fontSize: 17,
                                        fontWeight: 400,
                                        color: "#6B7C4F",
                                    }}
                                >
                                    {loc.name}
                                </strong>
                                <div style={{ fontSize: 12, marginTop: 6, color: "#4C523F" }}>
                                    {loc.street}
                                    <br />
                                    {loc.city}, {loc.state} {loc.zip}
                                </div>
                                <div style={{ marginTop: 8, fontSize: 12 }}>
                                    <a
                                        href={`tel:${loc.phone_tel || loc.phone}`}
                                        style={{
                                            color: "#6B7C4F",
                                            textDecoration: "none",
                                        }}
                                    >
                                        {loc.phone}
                                    </a>
                                </div>
                                <a
                                    href={loc.store_url}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    style={{
                                        display: "inline-block",
                                        marginTop: 10,
                                        padding: "8px 14px",
                                        background: "#6B7C4F",
                                        color: "#F2EDE2",
                                        fontSize: 10,
                                        textTransform: "uppercase",
                                        letterSpacing: "0.25em",
                                        textDecoration: "none",
                                    }}
                                >
                                    Shop this store →
                                </a>
                            </div>
                        </Popup>
                    </Marker>
                ))}
            </MapContainer>
        </div>
    );
}
